<template>
	<div class="row" v-if="messages" >
		<div class="col-12">
			<div class="alert"
             :class="'alert-'+message.state"
             role="alert"
             v-for="(message, index) in messages"
             :key="message.state+'-msg--'+index"
				 v-html="message.text">

			</div>
		</div>
	</div>
</template>
<script>

	export default {
		name: 'form-message',
		props: [
			'messages'
		],
		data() {
			return {}
		},
		computed: {

		},
		methods: {


		}
	}

</script>
